<div *ngFor="let notification of notifications">
  <div class="app-habitation-v2 notifications-container">
    <app-preautorisation-notification
      [id]="notification.id"
      *ngIf="notification.type === notificationTypePreautorisation && !isDSD"
    ></app-preautorisation-notification>
  </div>
  <app-preautorisation-notification-dsd
    [id]="notification.id"
    *ngIf="notification.type === notificationTypePreautorisation && isDSD"
  ></app-preautorisation-notification-dsd>
</div>
